import React from 'react';
import { domainLogoWhite, domainLogoAlt } from '../../../components/domain-logo';
import { PoweredByAffiliation } from '../../../components/powered-by-affiliation';
import OnboardingImage from '../../../assets/images/onboarding.png';
import { RedirectHeader } from '../../../components/layout/redirect-header';
import { useMediaQuery } from '../../../hooks/utils/useMediaQuery';
import { usePoweredByBranding } from '../../../hooks/usePoweredByBranding';

interface OnboardingLayoutProps {
  children: React.ReactNode;
}

export const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({ children }) => {
  const dfMdMedia = useMediaQuery('md');
  const { enabled: poweredByEnabled, clientLogoUrl } = usePoweredByBranding();

  const heroLogoSrc = poweredByEnabled && clientLogoUrl ? clientLogoUrl : domainLogoWhite;
  const heroLogoAlt = poweredByEnabled && clientLogoUrl ? 'Client logo' : domainLogoAlt;

  return (
    <>
      {!dfMdMedia && <RedirectHeader />}
      <div className="grid min-h-screen w-screen grid-cols-1 md:min-h-screen md:grid-cols-2">
        {/* HERO SECTION: flex column so image shrinks with viewport and tagline stays below */}
        <div className="from-profile-gradient-start to-profile-gradient-end hidden bg-gradient-to-b md:flex md:h-full md:flex-col md:items-center md:justify-center md:overflow-hidden">
          <div
            className={`flex h-full w-full max-w-[680px] flex-col px-8 py-8 md:mt-2 md:py-10 ${
              poweredByEnabled ? '' : 'md:mb-20 md:justify-center'
            }`}
          >
            <div className="flex-shrink-0">
              <img
                src={heroLogoSrc}
                alt={heroLogoAlt}
                className="h-8 w-auto max-w-[220px] object-contain object-left"
              />
            </div>
            <div className={`mt-8 flex min-h-0 flex-col items-center md:mt-10 ${poweredByEnabled ? 'flex-1' : ''}`}>
              <div className="w-full rounded-lg">
                <img
                  src={OnboardingImage}
                  alt="Onboarding"
                  className="ml-12 h-auto max-h-[min(640px,62vh)] w-full rounded-lg object-contain object-center"
                />
              </div>
              <p className="font-albert-sans md:leading-12 mt-6 whitespace-pre-wrap text-[min(2.25rem,4.5vh)] font-medium leading-tight text-white md:mt-12 md:text-[min(2rem,5vh)]">
                connect. grow. thrive.
              </p>
            </div>
            {poweredByEnabled ? (
              <div className="mt-8 flex flex-shrink-0 justify-start md:mt-10">
                <PoweredByAffiliation enabled variant="dark" align="start" />
              </div>
            ) : null}
          </div>
        </div>

        {/* CONTENT SECTION: min-h-screen on mobile so grey fills viewport when hero is hidden */}
        <div className="md:px-30 flex min-h-screen flex-col bg-gray-100 px-5 py-8 pt-8 md:min-h-full md:justify-center">
          <div className="max-w-118 mx-auto w-full flex-1 md:flex-none">
            <div className="border-input-border-gray rounded-xl border bg-white p-6">{children}</div>
          </div>
          {/* Mobile: Powered by affiliation at bottom of screen (not inside the form card) */}
          {!dfMdMedia && poweredByEnabled ? (
            <div className="max-w-118 mx-auto mt-8 flex w-full justify-center pb-2">
              <PoweredByAffiliation enabled variant="light" align="center" />
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};
